import type { FC, InputHTMLAttributes } from 'react'
import { Controller } from 'react-hook-form'
import { moneyFormatter } from '../../shared/utils/formatters'

interface MoneyInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error: boolean
  name: string
  suffix?: string
}

const MoneyInput: FC<MoneyInputProps> = ({
  className,
  error,
  name,
  id,
  suffix,
  maxLength = 9,
  onBlur,
  onFocus,
}) => (
  <Controller
    name={name}
    render={({ field }) => (
      <div className="relative">
        <input
          {...field}
          onBlur={(e) => onBlur && onBlur(e)}
          onFocus={(e) => onFocus && onFocus(e)}
          onChange={(e) => field.onChange(moneyFormatter(e.target.value || ''))}
          value={field.value}
          className={className}
          inputMode="decimal"
          maxLength={maxLength}
          type="text"
          id={id}
        />
        <span
          className={`absolute font-normal text-ink-600 top-[calc(50%_-_8px)] ${
            error ? 'right-el' : 'right-m'
          }`}
        >
          {suffix}
        </span>
      </div>
    )}
  />
)

export default MoneyInput
